// extracted by mini-css-extract-plugin
export default {"tableTopperMain":"styles_tableTopperMain__YB8+C","open":"styles_open__3z3WC","tableTopperContainer":"styles_tableTopperContainer__JqCZ0","toggleHolder":"styles_toggleHolder__O-0e-"};